import { ValidationError } from '../api/usePhysicianEmailStatement'

export interface ParsedError {
  message: string
  severity: 'error' | 'warning'
}

export const parseEmailStatementError = (error: any): ParsedError => {
  const errorData = error?.response?.data

  // Handle rate limit error (Type 1)
  if (errorData?.message && errorData?.nextAvailableTime) {
    const nextTime = new Date(errorData.nextAvailableTime)
    const formattedTime = nextTime.toLocaleTimeString([], { 
      hour: '2-digit', 
      minute: '2-digit',
      timeZone: 'UTC'
    })
    
    return {
      message: `Rate limit exceeded. Next request available at ${formattedTime}.`,
      severity: 'warning'
    }
  }

  // Handle validation errors (Type 2)
  if (Array.isArray(errorData) && errorData.length > 0) {
    const validationError = errorData[0] as ValidationError
    if (validationError.attribute === 'email') {
      return {
        message: validationError.errorMessage,
        severity: 'error'
      }
    }
  }

  // Generic error fallback
  return {
    message: 'An error occurred while sending the email statement.',
    severity: 'error'
  }
}